import { useState, useEffect } from "react";

export const useUserNameValidation =(username='') =>{
    const [ validLength, setValidLength] = useState(null)
    const [isAlphaNumeric, setIsAlphaNumeric] = useState(true)
    useEffect(() => {
        setValidLength(username?.length >=3 && username.length<=50 ?true:false)
        setIsAlphaNumeric(!(/[`!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/.test(username)))
    }, [username])
    return [isAlphaNumeric,validLength]
}